import { Component } from '@angular/core';
import { Storage } from '@ionic/storage';
import { Platform, NavController } from '@ionic/angular';
import { AuthService } from './services/auth.service';
import { SplashScreen } from '@ionic-native/splash-screen/ngx';
import { StatusBar } from '@ionic-native/status-bar/ngx';
import { AlertService } from './services/alert.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { EnvService } from './services/env.service';

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss']
})
export class AppComponent {
  constructor(
    private authService: AuthService,
    private platform: Platform,
    private splashScreen: SplashScreen,
    private statusBar: StatusBar,
    private navCtrl: NavController,
    private storage: Storage,
    private http: HttpClient,
    private env: EnvService,
    private alertService: AlertService
  ) {
    this.initializeApp();
  }

  initializeApp() {
    this.platform.ready().then(() => {
      this.statusBar.styleDefault();
      this.statusBar.overlaysWebView(true);
      this.splashScreen.hide();
      // this.authService.isLoggedIn();
      this.authService.authState.subscribe(state => {
        if (state) {
          this.http.get(this.env.API_URL + 'show-wizard', { headers: this.authService.headers })
            .toPromise()
            .then(
              response => {
                if (response['show_wizard']) {
                  this.navCtrl.navigateRoot(['./wizard']);
                }
                else {
                  this.navCtrl.navigateRoot(['/tabs']);
                }
              },
              error => console.error('Error saving token', error)
            );
        } else {
          this.navCtrl.navigateRoot(['login']);
        }
      });
    });
  }



}
